import { defineRecipe, defineStyle } from '@chakra-ui/react';

/*
 * v3 port notes: the built-in `spinner` recipe has no `variant` category at
 * all (only `size`) — this file adds one, matching v2's original shape.
 * No `defaultVariants` here (same as v2), so `primary` only applies when a
 * caller explicitly passes `variant="primary"`.
 */

const variantPrimary = defineStyle({
  borderColor: 'tIndigo.base',
});

export const spinnerTheme = defineRecipe({
  variants: {
    variant: {
      primary: variantPrimary,
    },
  },
});

export default spinnerTheme;
